import { useGetVisitorProfileData } from '../../../Pages/Visitor/apiEndpoints/VisitorApiEndpoints';
import CreateTicketingRequest from '../../../Pages/Visitor/TicketingRequest/CreateTicketingRequest';
import CommonStatus from '../../Common/CommonStatus';
const VisitorProfileHomePage = () => {
  const { data } = useGetVisitorProfileData();
  return (
    <div>
      <div className='profile-right-side px-3 py-3'>
        <div className='d-flex  align-items-center justify-content-between'>
          <h4 className='component-tittle'>Profile Information</h4>
        </div>
        <div className='profile-right-info pt-3 ps-2'>
          <ul>
            <li>
              <span>Name</span> :{' '}
              <p>
                {data?.data?.visitor_first_name} {data?.data?.visitor_last_name}
              </p>
            </li>
            <li>
              <span>Email</span> : <p>{data?.data?.visitor_email}</p>
            </li>
            <li>
              <span>Phone</span> : <p>{data?.data?.visitor_phone}</p>
            </li>

            <li>
              <span>Organization</span> :{' '}
              <p>{data?.data?.visitor_organization}</p>
            </li>

            <li>
              <span>Designation</span> :{' '}
              <p>{data?.data?.visitor_designation}</p>
            </li>

            <li>
              <span>Address</span> : <p>{data?.data?.visitor_address}</p>
            </li>
            <li>
              <span>Status</span> :{' '}
              <p>{CommonStatus(data?.data?.visitor_status)}</p>
            </li>
          </ul>
        </div>

        {/* <CreateTicketingRequest /> */}
      </div>
    </div>
  );
};

export default VisitorProfileHomePage;
